export const TOGGLE_MODAL = 'TOGGLE_MODAL'

export const LOG_MESSAGE = 'LOG_MESSAGE'